// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"86df5e80a789da618697","418":"3d747bc22bb0d5dbb9ff","661":"471b3332e29001ffa97d"}[chunkId] + ".bundle.js";
};